/*
    Copyright (c) Computer-L.A.N. GmbH (http://www.computer-lan.de).
    Alle Rechte vorbehalten.
*/

export default class ResponseUtil {
    public static async toFile(response: Response): Promise<File> {
        const contentDisposition = response.headers.get("Content-Disposition");
        const contentType = response.headers.get("Content-Type") ?? "";
        let filename = "Unbekannt.pdf";
        const regExArray = contentDisposition?.match(/filename=(.+)/);
        if (regExArray) {
            filename = regExArray[1];
            filename = filename.split("\"").join("");
        }

        const blob = await response.blob();
        return new File([blob], filename, { type: contentType });
    }
}